import React, { useEffect } from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs";
import Allservices from "./Mainservices/Allservices";
import { Helmet } from "react-helmet";
import './shoot.css'
import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
export default function ProductShoot() {
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
  useEffect(() => {
    const elements = document.querySelectorAll(".fadeup")
    const oberver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible")
        }
      });
    },
      { threshold: 0.2 }
    );
    elements.forEach(el => oberver.observe(el));
  }, [])
  return (
    <>
      <Helmet>
        <title>
          Best Media Production Company in Navi Mumbai | Media Production Agency In Navi Mumbai
        </title>
        <link rel="canonical" href="https://www.twinklemediahub.com/mediaProduction" />
        <meta
          name="description"
          content="Twinkle Media Hub - Best Media Production Agency in Navi Mumbai - Our Media Production company in Navi Mumbai offers affordable SEO services to boost your online presence & drive traffic with the best SEO Practices."
        />
        <meta
          name="keywords"
          content="Twinkle Media Hub Media Production Experts, Media Production services, Media Production agency in Mumbai, Media Production company in Mumbai, best seo company in mumbai, Search Engine Optimization Services in Mumbai, SEO Services Mumbai, Mumbai Search Engine Optimization, On-Page SEO Optimization, Off-Page SEO Strategies, Local SEO Mumbai, SEO Audits, Mumbai Keyword Research, Result-Driven SEO Services, Mumbai Digital Marketing Agency"
        />
        <meta
          property="og:title"
          content="Best Media Production Company in Navi Mumbai | Media Production Agency In Navi Mumbai"
        />
        <meta
          property="og:site_name"
          content="Twinkle Media Hub Services Pvt. Ltd."
        />
        <meta property="og:url" content="https://twinklemediahub.com/mediaProduction" />
        <meta
          property="og:description"
          content="Twinkle Media Hub - Best Media Production Agency in Navi Mumbai - Our Media Production company in Navi Mumbai offers affordable Media Production services to boost your online presence & drive traffic with the best SEO Practices."
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="">
        <Breadcrumbs
          breadheading={"Media Production"}
          breadcrumbsLabel={"Media Production"}
        />
        <section className="hero-section" id="graphic-section">
          <div className="hero-content">
            <Allservices
              Serviceh1={"Bringing Your Products to Life "}
              Serviceh1span={"with Twinkle Media Hub Pvt Ltd"}
            // h4para={""}
            />
            {/* <h1>
              Social Media Marketing <br /> Agency In Navi Mumbai
            </h1> */}

            <p className="Graphicsubtitle">
              Twinkle Media Hub Pvt Ltd: Your Trusted Partner in Creative Media Production Services in Mumbai
            </p>

            <p className="Graphicdescription">
              At Twinkle Media Hub Pvt Ltd, we specialize in delivering top-notch media production services that cater to all your visual storytelling needs. Our extensive range of services is designed to help your brand shine across various platforms, ensuring you make a lasting impact on your audience.
            </p>

            <button className="hero-btn"><Link to="/contact">Get Started</Link></button>
          </div>

          <div className="hero-image commercial-image">
            <img src='./asset/media/media.png' alt="Shoot" />
          </div>
        </section>
      </div>
      <div className="container">
        {/* <div className="sw-main-content mt-2">
          <p>
            At Twinkle Media Hub Pvt Ltd, we specialize in delivering top-notch
            media production services that cater to all your visual storytelling
            needs. Our extensive range of services is designed to help your
            brand shine across various platforms, ensuring you make a lasting
            impact on your audience.
          </p>
        </div> */}

        {/* <div className="row">
          <div className="col-lg-8 col-md-6 col-sm-12">
            <div className="sw-main-content mt-3">
              <p>
                The Influence of various Social Media platforms is growing day
                by day, Almost every brand is trying their best to reach their
                target audience and have a long-lasting impact on them, but very
                few are successful in tapping the right chords at the right
                platform and at the right time.
              </p>

              <p>
                The Influence of various Social Media platforms is growing day
                by day, Almost every brand is trying their best to reach their
                target audience and have a long-lasting impact on them, but very
                few are successful in tapping the right chords at the right
                platform and at the right time.
              </p>

              <p>
                The Influence of various Social Media platforms is growing day
                by day, Almost every brand is trying their best to reach their
                target audience and have a long-lasting impact on them, but very
                few are successful in tapping the right chords at the right
                platform and at the right time.
              </p>

              <p>
                The Influence of various Social Media platforms is growing day
                by day, Almost every brand is trying their best to reach their
                target audience and have a long-lasting impact on them, but very
                few are successful in tapping the right chords at the right
                platform and at the right time.
              </p>

              <p>
                The Influence of various Social Media platforms is growing day
                by day, Almost every brand is trying their best to reach their
                target audience and have a long-lasting impact on them, but very
                few are successful in tapping the right chords at the right
                platform and at the right time.
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <img
              src="./asset/img/digitalwebsite.png "
              alt="images-smm"
              className="w-100"
            />
          </div>
        </div> */}
        <div className="section-wrapper">

          <h2 className="main-title fadeup">Commercial Ad Shoots</h2>

          <p className="top-description fadeup">
            In today’s competitive market, creating compelling advertisements is crucial for capturing your audience’s attention.
            Our Commercial Ad Shoots are meticulously crafted to highlight your brand’s unique selling points, engage your target
            audience, and drive results. From concept development to final production, we ensure every element of your ad resonates
            with your brand identity.
          </p>

          <div className="image-row fadeup">
            <img src="./asset/media/media6.webp" alt="img1" />
            <img src="./asset/media/media5.webp" alt="img2" />
            <img src="./asset/media/media4.webp" alt="img3" />
            <img src="./asset/media/media3.webp" alt="img4" />
          </div>

        </div>
        {/* <h2>Commercial Ad Shoots</h2>
        <span className="animate-border tw-mt-20 tw-mb-40 mr-auto ml-auto"></span>
        <div className="sw-main-content mt-3">
          <p>
            In today's competitive market, creating compelling advertisements is
            crucial for capturing your audience's attention. Our Commercial Ad
            Shoots are meticulously crafted to highlight your brand's unique
            selling points, engage your target audience, and drive results. From
            concept development to final production, we ensure every element of
            your ad resonates with your brand identity.
          </p>
        </div> */}

        {/* <h3>Commercial Photography</h3>
        <span className="animate-border tw-mt-20 tw-mb-40 mr-auto ml-auto"></span>
        <div className="sw-main-content mt-3">
          <p>
            At Twinkle Media Hub, our Commercial Photography services are
            tailored to meet the unique needs of your business. We combine
            artistic vision with technical expertise to create images that not
            only look great but also convey your brand message effectively. From
            product photography to lifestyle shoots, we deliver visuals that
            captivate and convert.
          </p>
        </div> */}

        {/* <h3>Corporate Photoshoots</h3>
        <span className="animate-border tw-mt-20 tw-mb-40 mr-auto ml-auto"></span>
        <div className="sw-main-content mt-3">
          <p>
            Our Corporate Photoshoots are designed to capture the professional
            essence of your team and office environment. Whether for your
            website, annual reports, or marketing collateral, we create images
            that reflect your company's professionalism and ethos, helping you
            build a strong and trustworthy brand image.
          </p>
        </div> */}
        <div className="section-wrapper">

          <h2 className="main-title">Product Shoots</h2>

          <p className="top-description">
            Showcasing your products in the best light is crucial for driving sales and customer engagement. Our Product Shoot services are designed to highlight the unique features and benefits of your products, creating images that entice and inform potential customers. Our Product Photography services provide high-quality, detailed images that make your products stand out. Whether for e-commerce, catalogs, or promotional materials, we focus on capturing the essence of your products, ensuring they look appealing and desirable to your target audience.
          </p>

          <div className="image-row">
            <img src="./asset/media/media10.webp" alt="img1" />
            <img src="./asset/media/media11.webp" alt="img2" />
            <img src="./asset/media/media12.webp" alt="img3" />
            <img src="./asset/media/media13.webp" alt="img4" />
          </div>

        </div>
        {/* <h3>Product Shoot</h3>
        <span className="animate-border tw-mt-20 tw-mb-40 mr-auto ml-auto"></span>
        <div className="sw-main-content mt-3">
          <p>
            Showcasing your products in the best light is crucial for driving sales and customer engagement. Our Product Shoot services are designed to highlight the unique features and benefits of your products, creating images that entice and inform potential customers. Our Product Photography services provide high-quality, detailed images that make your products stand out. Whether for e-commerce, catalogs, or promotional materials, we focus on capturing the essence of your products, ensuring they look appealing and desirable to your target audience.
          </p>
        </div> */}
        {/* <h3>Chroma Video Ad Shoots</h3>
        <span className="animate-border tw-mt-20 tw-mb-40 mr-auto ml-auto"></span>
        <div className="sw-main-content mt-3">
          <p>
            Take your video advertisements to the next level with our Chroma Video Ad Shoots. Utilizing green screen technology, we create dynamic and engaging video content that can be placed in any setting or background, providing limitless creative possibilities for your marketing campaigns.
          </p>
        </div> */}
        <div className="section-wrapper">

          <h2 className="main-title">Model Shoots</h2>

          <p className="top-description">
            We create impactful model shoots that showcase your brand’s style, emotion, and message through professional lighting, direction, and photography.
          </p>

          <div className="image-row">
            <img src="./asset/media/model1.webp" alt="img2" />
            <img src="./asset/media/model2.webp" alt="img3" />
            <img src="./asset/media/model3.webp" alt="img4" />
            <img src="./asset/media/model4.webp" alt="img6" />
            <img src="./asset/media/model5.webp" alt="img7" />
            <img src="./asset/media/model6.webp" alt="img8" />
            <img src="./asset/media/model7.webp" alt="img9" />
            <img src="./asset/media/model8.webp" alt="img10" />
            <img src="./asset/media/model9.webp" alt="img11" />
            <img src="./asset/media/model10.webp" alt="img12" />
            <img src="./asset/media/model11.webp" alt="img13" />
            <img src="./asset/media/model12.webp" alt="img14" />
            <img src="./asset/media/model13.webp" alt="img15" />
            <img src="./asset/media/model14.webp" alt="img16" />
            <img src="./asset/media/model15.webp" alt="img17" />
            <img src="./asset/media/model16.webp" alt="img18" />
            <img src="./asset/media/model17.webp" alt="img19" />
            <img src="./asset/media/model21.webp" alt="img24" />
            <img src="./asset/media/model19.webp" alt="img22" />
            <img src="./asset/media/model20.webp" alt="img23" />
            <img src="./asset/media/model18.webp" alt="img20" /> 
            <img src="./asset/media/model22.webp" alt="img25" />
          </div>

        </div>
        {/* <button className="serv-btn">Get Quote</button> */}
        <div className="Shootcta-section">
          <div className="Shootcta-content">
            <h2 className="Shootcta-title">Ready to Elevate Your Brand with High-Quality Shoots?</h2>
            <p className="Shootcta-description">
              Contact Twinkle Media Hub today to explore how our professional shoot services can elevate your digital strategy. Trust us for creative excellence and high-impact visual content.
            </p>
            <Link to='/contact'>
              <button className="Shootcta-button">
                <MessageCircle size={20} />
                Contact Us Now
                <ArrowRight size={20} />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
